import { PropInteractionDTO } from "../../dto/PropInteractionDTO";

export default function PropLibraryInteractionLabel(props: {
  interactionName: string;
}) {
  const { interactionName } = { ...props };

  return (
    <div
      className={
        "flex rounded-full border-2 border-solid gap-[10px] h-[36px] px-[10px] border-creator-text-faded max-w-[200px]"
      }
    >
      <div className={"my-auto font-medium truncate text-creator-text-sub"}>
        {interactionName}
      </div>
    </div>
  );
}
